import { BaseResourceModel } from '../../models/base-resource.model';

// tslint:disable: variable-name

export class Parlamentares extends BaseResourceModel {
  constructor(
    public id?: number,
    public nome?: string,
    public nome_civil?: string,
    public tipo_identificacao?: number,
    public data_inicial?: Date,
    public data_final?: Date,
  ) {
    super();
  }

  static converteJson(json: any): Parlamentares {
    return Object.assign(new Parlamentares(), json);
  }
}
